"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = exports.EmeraldStatusDotType = exports.EmeraldStatusIconType = exports.EmeraldLabelPosition = void 0;
var EmeraldLabelPosition;
(function (EmeraldLabelPosition) {
    EmeraldLabelPosition["LEFT"] = "left";
    EmeraldLabelPosition["RIGHT"] = "right";
})(EmeraldLabelPosition || (exports.EmeraldLabelPosition = EmeraldLabelPosition = {}));
var EmeraldStatusIconType;
(function (EmeraldStatusIconType) {
    EmeraldStatusIconType["WARNING"] = "Warning";
    EmeraldStatusIconType["ERROR"] = "Error";
    EmeraldStatusIconType["INFO"] = "Info";
    EmeraldStatusIconType["IN_PROGRESS"] = "InProgress";
    EmeraldStatusIconType["COMPLETE"] = "Complete";
    EmeraldStatusIconType["FLAG"] = "Flag";
    EmeraldStatusIconType["TREND_UP"] = "TrendUp";
    EmeraldStatusIconType["TREND_DOWN"] = "TrendDown";
    EmeraldStatusIconType["TREND_ZERO"] = "TrendZero";
})(EmeraldStatusIconType || (exports.EmeraldStatusIconType = EmeraldStatusIconType = {}));
var EmeraldStatusDotType;
(function (EmeraldStatusDotType) {
    EmeraldStatusDotType["OUT_LINE"] = "Outline";
    EmeraldStatusDotType["BLUE"] = "Blue";
    EmeraldStatusDotType["AMBER"] = "Amber";
    EmeraldStatusDotType["RED"] = "Red";
    EmeraldStatusDotType["GREEN"] = "Green";
    EmeraldStatusDotType["GRAY"] = "Gray";
})(EmeraldStatusDotType || (exports.EmeraldStatusDotType = EmeraldStatusDotType = {}));
const stringify = (obj) => {
    const sortObjectKeys = (obj) => {
        if (typeof obj !== 'object' || obj === null) {
            return obj;
        }
        if (Array.isArray(obj)) {
            return obj.map(sortObjectKeys);
        }
        const sortedObj = {};
        Object.keys(obj)
            .sort()
            .forEach((key) => {
            sortedObj[key] = sortObjectKeys(obj[key]);
        });
        return sortedObj;
    };
    const safeStringify = (obj) => {
        const seen = new WeakSet();
        return JSON.stringify(obj, (key, value) => {
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                    return; // Discard circular references
                }
                seen.add(value);
            }
            return value;
        });
    };
    const sortedObj = sortObjectKeys(obj);
    return safeStringify(sortedObj);
};
exports.stringify = stringify;
//# sourceMappingURL=common.js.map